/**
 * Renders the "≈ ₱64,000.00 from the contract" line beside an invoice's
 * USD amount. Driven by the `contractEquivalent` field on the invoice doc
 * (see functions/src/gcp_billing/partner_portal_api.js for the pass-through).
 *
 * Use whenever an invoice is shown in the portal — invoice table row, Pay
 * Now modal, invoice detail page, post-card-add callout — so Tito Steve
 * and JPA always see both the billed currency (USD) and the contract
 * currency (PHP) without ambiguity.
 */
import React from 'react';
import { formatCurrency } from '../utils/formatters';
import './ContractEquivalent.css';

export function ContractEquivalent({ invoice, className = '' }) {
  const ce = invoice?.contractEquivalent;
  if (!ce || !ce.amount || !ce.currency) return null;

  const billingCurrency = invoice.currency || 'USD';
  // Use toFixed(2) so PHP 55.50/USD doesn't render as PHP 55.5/USD —
  // JS strips trailing zeros on number → string and rates look truncated.
  const rateText = ce.fxRate
    ? ` (${ce.currency} ${Number(ce.fxRate).toFixed(2)}/${billingCurrency}${ce.fxLockedAt ? `, locked ${ce.fxLockedAt}` : ''})`
    : '';

  return (
    <div className={`contract-equivalent ${className}`}>
      <span className="contract-equivalent-approx">≈</span>{' '}
      <span className="contract-equivalent-amount">
        {formatCurrency(ce.amount, ce.currency)}
      </span>{' '}
      <span className="contract-equivalent-suffix">from the contract{rateText}</span>
    </div>
  );
}

export default ContractEquivalent;
